import React from 'react';

import BaseIcon, { type BaseIconProps } from '../../BaseIcon';

const MaxIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 40 40" fill="none">
      <defs>
        <linearGradient
          id="max_bg_grad"
          x1="0"
          y1="0"
          x2="40"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#00B0FF" />
          <stop offset="100%" stopColor="#6C45E0" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="20" fill="url(#max_bg_grad)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2116 29.7297C18.2829 29.7297 17.3866 29.4481 15.8286 28.3219C14.8431 29.5889 11.7224 30.5791 11.5863 28.885C11.5863 27.6133 11.3048 26.5386 10.9857 25.3655C10.6056 23.9201 10.1738 22.3105 10.1738 19.9782C10.1738 14.4079 14.7446 10.2173 20.16 10.2173C25.5801 10.2173 29.827 14.6144 29.827 20.0298C29.8452 25.3615 25.5432 29.7013 20.2116 29.7297ZM20.2914 15.032C17.6541 14.8959 15.5986 16.7214 15.1434 19.584C14.768 21.9538 15.4344 24.8399 16.0022 24.99C16.2744 25.0557 16.9595 24.502 17.3866 24.0749C18.0927 24.5628 18.915 24.8557 19.7705 24.9243C22.5032 25.0558 24.8382 22.9754 25.0217 20.2457C25.1285 17.5102 23.0245 15.1933 20.2914 15.0367L20.2914 15.032Z"
        fill="white"
      />
    </BaseIcon>
  );
};

export default MaxIcon;
